import $http from '@/libs/axios'

class HelpAPI {
  public static async sections() {
    const sections = (await $http.get('/help/sections')).data
    if (!sections || !Array.isArray(sections)) return []
    return sections
  }

  public static async add(data: any, type: 'question' | 'section') {
    return (await $http.post(`help/${type}/add`, data)).data
  }

  public static async edit(data: any, type: 'question' | 'section') {
    return (await $http.put(`help/${type}/update`, data)).data
  }

  public static async delete(id: any, type: 'question' | 'section') {
    return (await $http.delete(`help/${type}/delete/${id}`)).data
  }

  public static async show(id: any, type: 'question' | 'section') {
    return (await $http.get(`help/${type}/${id}`)).data
  }
}

export default HelpAPI
